// workLogActions.js
import axios from "../helpers/axios";
import { workLogConstants as C } from "./constants";

export const listWorkLogs = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: C.LIST_REQUEST });
        const res = await axios.get("/worklog", { params });
        dispatch({
            type: C.LIST_SUCCESS,
            payload: {
                items: res.data.items || [],
                totalMinutes: res.data.totalMinutes || 0,
                totalAmount: res.data.totalAmount || 0,
            },
        });
    } catch (e) {
        dispatch({ type: C.LIST_FAILURE, error: e?.response?.data?.message || e.message });
    }
};

export const startWorkLog = (payload) => async (dispatch) => {
    try {
        dispatch({ type: C.START_REQUEST });
        const res = await axios.post("/worklog/start", payload);
        dispatch({ type: C.START_SUCCESS, payload: res.data.doc });
        return res.data.doc;
    } catch (e) {
        dispatch({ type: C.START_FAILURE, error: e?.response?.data?.message || e.message });
        throw e;
    }
};

export const stopWorkLog = (id) => async (dispatch) => {
    try {
        dispatch({ type: C.STOP_REQUEST });
        const res = await axios.post(`/worklog/${id}/stop`);
        dispatch({ type: C.STOP_SUCCESS, payload: res.data.doc });
        return res.data.doc;
    } catch (e) {
        dispatch({ type: C.STOP_FAILURE, error: e?.response?.data?.message || e.message });
        throw e;
    }
};

export const updateWorkLog = (id, payload) => async (dispatch) => {
    try {
        dispatch({ type: C.UPDATE_REQUEST });
        const res = await axios.put(`/worklog/${id}`, payload);
        dispatch({ type: C.UPDATE_SUCCESS, payload: res.data.doc });
        return res.data.doc;
    } catch (e) {
        dispatch({ type: C.UPDATE_FAILURE, error: e?.response?.data?.message || e.message });
        throw e;
    }
};

export const payWorkLog = (id, payload) => async (dispatch) => {
    try {
        dispatch({ type: C.PAY_REQUEST });
        const res = await axios.post(`/worklog/${id}/pay`, payload);
        dispatch({ type: C.PAY_SUCCESS, payload: res.data.doc });
        return res.data.doc;
    } catch (e) {
        dispatch({ type: C.PAY_FAILURE, error: e?.response?.data?.message || e.message });
        throw e;
    }
};

export const setWorkLogWidgetOpen = (v) => ({ type: C.SET_WIDGET_OPEN, payload: !!v });
